import type { SuggestionResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toSuggestion } from './toSuggestion';

function toSuggestionDomain(args: { dtos: SuggestionResponse[] }) {
  const { dtos } = args;

  const suggestionDomain: NormalizedDomain<Data.Suggestion> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const suggestion = toSuggestion(item);
      if (suggestion === undefined) return;
      domainUtility.mutateAdd(suggestionDomain, suggestion);
    },
  });

  return { suggestionDomain };
}

export { toSuggestionDomain };
